<template>
    <v-row align="center">
      <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 home-box">
        <v-col>
            <v-col class="d-flex align-center flex-column justify-center mt-10">
                <v-img class="bg-white"  src="../../assets/img/not_found_image.svg" alt="Not Found Image"></v-img>
            </v-col>
        </v-col>
      </div>
    </v-row>
  </template>
  <script>
  
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "NotFound",
    components: {
      
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
  
  };
  </script>